import { useTheme } from '@mui/material';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: theme.spacing(0.5),
            paddingTop: theme.spacing(0.5),
            [theme.breakpoints.up('sm')]: {
                marginTop: theme.spacing(2),
            },
            '& > h1, h2, h3, h4, h5, h6': {
                marginBottom: theme.spacing(1),
            },
        },
        loadingContainer: {
            position: 'absolute',
            width: '100%',
            marginTop: theme.spacing(20),
            pointerEvents: 'none',
        },
    };
};
